import { render, staticRenderFns } from "./onlineProduct.vue?vue&type=template&id=ba57a08a&scoped=true"
import script from "./onlineProduct.vue?vue&type=script&lang=js"
export * from "./onlineProduct.vue?vue&type=script&lang=js"
import style0 from "./onlineProduct.vue?vue&type=style&index=0&id=ba57a08a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba57a08a",
  null
  
)

export default component.exports